export default "__VITE_ASSET__BaUTwrQu__"